import React from 'react';
import PropTypes from 'prop-types';

import Image from '../Image';
import Icon from '../Icon';
import FixAspect from '../FixedAspect';
import ClickableWrap from '../ClickableWrap';

import './styles.less';

const Sidekick = (props) => {
    const body = (
        <div className="p-sidekick__body">
            <div className={`p-scrim p-sidekick__scrim p-sidekick__scrim--position-${props.scrimPosition}`}>
                {props.icon ? <Icon {...props.icon} className="p-sidekick__icon" /> : null}
                {props.title}
            </div>
        </div>
    );

    return (
        <div className={`p-sidekick ${props.className}`} data-content-id={props.contentId} style={props.style}>
            <ClickableWrap url={props.url} openInNewTab={props.openInNewTab}>
                {props.image ? <Image {...props.image} /> : null}
                {!props.image ? <FixAspect ratio={props.aspectRatio}>{body}</FixAspect> : body}
            </ClickableWrap>
        </div>
    );
};

Sidekick.propTypes = {
    scrimPosition: PropTypes.oneOf(['bottom', 'middle', 'top', 'cover']),
    image: PropTypes.shape(Image.propTypes),
    icon: PropTypes.shape(Icon.propTypes),
    title: PropTypes.string.isRequired,
    url: PropTypes.string,
    openInNewTab: PropTypes.bool,
    //isAbsoluteUrl: PropTypes.url,
    contentId: PropTypes.string,
    aspectRatio: PropTypes.string, //required if no image
    style: PropTypes.shape({}),
    className: PropTypes.string
};

Sidekick.defaultProps = {
    title: '',
    scrimPosition: 'bottom',
    image: undefined,
    icon: undefined,
    url: undefined,
    contentId: undefined,
    aspectRatio: undefined,
    style: undefined,
    className: undefined,
    openInNewTab: false
};

export default Sidekick;
